import { Component, DoCheck, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserDetailsService } from '../../../services/user-details.service';
import { EmitterService } from '../../../services/emitter.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-custom-selector',
  templateUrl: './custom-selector.component.html',
  styleUrls: ['./custom-selector.component.scss']
})
export class CustomSelectorComponent implements OnInit, DoCheck {

  @Input() selectorData = [];
  @Input() minimumSelectorListCount = 4;
  selectedValue;
  @Output() emitSelectedValue = new EventEmitter<any>();
  isShowList= false;
  isShowMoreClicked = false;
  allMethodsList = [];
  userCurrency;
  
  constructor(private userDetailsService:UserDetailsService, private emitterService:EmitterService, private translateService:TranslateService) { }

  ngOnInit(): void {
    if(this.selectorData?.length){
      this.selectorData = this.selectorData.filter((method)=>{
        if(method.name.toLowerCase() != 'paymentiq')
        return method
      })
      this.selectedValue = this.selectorData[0];
      this.emitSelectedValue.emit(this.selectedValue);
      this.allMethodsList = [...this.selectorData];
      this.setDefault();
    }
    this.userCurrency = this.userDetailsService.getUserCurrencySymbol();
    this.emitterService.statusCall$.subscribe((status) =>{
      if(status == 'updated')
      this.userCurrency = this.userDetailsService.getUserCurrencySymbol();
    });
  }
  ngDoCheck(): void {
   if(this.selectorData?.length){
    this.selectorData = this.selectorData.filter((method)=>{
      if(method.name.toLowerCase() != 'paymentiq')
      return method
    })
   }
  }

  setDefault(){
    if(this.allMethodsList?.length > this.minimumSelectorListCount){
      this.isShowMoreClicked = false;
      this.selectorData.length = this.minimumSelectorListCount;
    }else{
      this.isShowMoreClicked = true;
    }
  }
  onChangeSelector(value){
    this.emitSelectedValue.emit(value);
    this.selectedValue = value;
    this.toggleSelector();
    this.emitterService.broadCastAddNewCardClick(true);
  }
  
  toggleSelector(){
    if(this.selectorData && this.selectorData.length >1){
      this.isShowList = !this.isShowList;
      if(!this.isShowList){
        this.setDefault();
      }
    }
  }
  showMoreList(){
    this.selectorData = [...this.allMethodsList];
    this.isShowMoreClicked = true;
  }
  getTranslation(key){
    return this.translateService.instant(key)
  }
}
